// Import model
import { TimeFieldOptions } from '../models/TimeFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TimeFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class TimeFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a TimeFieldOptions instance
   */
  static deserialize(json: string): TimeFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TimeFieldOptions instance
   */
  static fromObject(obj: any): TimeFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TimeFieldOptions');
    }


    const instance: TimeFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      f742Acfd: obj['_f742acfd'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TimeFieldOptions instances
   */
  static deserializeArray(json: string): TimeFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TimeFieldOptions instance to a JSON string
   */
  static serialize(instance: TimeFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TimeFieldOptions instance to a plain object
   */
  static toObject(instance: TimeFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_f742acfd': instance.f742Acfd,
    };
  }

  /**
   * Serializes an array of TimeFieldOptions instances to a JSON string
   */
  static serializeArray(instances: TimeFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
